export const imageRoutesDefinitions = {
  home: {
    path: 'search',
    name: 'imageHome'
  },
  images: {
    path: 'search/images/:id',
    name: 'imageViews'
  },
  results: {
    path: 'search/results',
    name: 'imageResults'
  }
};
